import {CSSProperties, FC} from 'react';


export interface IIconVkontakteProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconVkontakte: FC<IIconVkontakteProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm6.087 13.298c.56.546 1.151 1.06 1.653 1.663.223.267.432.542.592.852.228.443.022.928-.374.954H17.5c-.635.052-1.14-.204-1.566-.638-.34-.346-.656-.716-.983-1.074a2.302 2.302 0 0 0-.443-.393c-.335-.218-.626-.152-.818.199-.196.356-.24.75-.26 1.147-.026.58-.201.731-.783.759-1.243.058-2.422-.13-3.518-.757-.967-.553-1.715-1.333-2.367-2.216-1.27-1.722-2.243-3.611-3.116-5.555-.197-.438-.053-.672.43-.681a68.422 68.422 0 0 1 2.407-.001c.326.005.542.192.668.5a14.94 14.94 0 0 0 1.631 3.023c.178.25.359.5.617.678.285.195.502.13.636-.187a2.06 2.06 0 0 0 .142-.635c.064-.742.071-1.483-.04-2.222-.068-.462-.328-.76-.789-.848-.235-.045-.2-.131-.086-.266.198-.231.384-.375.755-.375h2.777c.438.086.536.282.596.723l.002 3.087c-.005.17.086.676.392.788.246.081.408-.116.555-.271.666-.707 1.14-1.541 1.565-2.405.188-.38.35-.775.507-1.17.117-.292.298-.435.628-.43l2.675.003c.078 0 .159 0 .237.014.45.077.574.271.434.71-.22.692-.646 1.267-1.063 1.844-.446.618-.923 1.214-1.365 1.835-.407.567-.375.852.13 1.345Z" clipRule="evenodd" />
        </svg>
    );
};
